"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconHassleFree = function SvgIconHassleFree(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "hassle free icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Hassle Free Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.577 27.627a4.383 4.383 0 013.519-1.777h4.049a.392.392 0 00.379-.491l-.66-2.505a4.092 4.092 0 01.783-3.61 4.015 4.015 0 011.713-1.222.39.39 0 00.253-.366V7.566A1.565 1.565 0 0031.048 6h-7.435a.391.391 0 00-.39.391v8.676a.783.783 0 01-1.336.553l-2.307-2.3a.393.393 0 00-.554 0l-2.3 2.3a.782.782 0 01-1.335-.553V6.391A.392.392 0 0014.998 6H7.565A1.565 1.565 0 006 7.565v21.913a1.565 1.565 0 001.565 1.565H21.38a.394.394 0 00.39-.427 4.343 4.343 0 01.807-2.99z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.827 41.942c1.786 0 3.045.058 4.092.058a13.4 13.4 0 006.859-1.863.392.392 0 00.224-.353V29.057a.391.391 0 00-.334-.386 2.232 2.232 0 01-1.473-.824l-4.962-7.024a1.736 1.736 0 00-3.099 1.44l.896 3.39a2.035 2.035 0 01-1.962 2.545h-4.972a2.034 2.034 0 00-1.94 2.619v.009l1.861 6.8v.021c.8 2.556 2.142 4.295 4.81 4.295z"
  }));
};

var _default = SvgIconHassleFree;
exports.default = _default;